import React from 'react'
import { Box } from 'ui/acro'
import { breakpoints } from 'ui/acro'
import EventCarouselCard from 'components_v1/EventsView/Cards/EventCarouselCard'
import EventCard from './Cards/EventGridCard'
import Carousel from 'components_v1/SchemaSectionRenderer/common/components/Carousel/Carousel'
import useEventAddToCalendar from 'hooks/useEventAddToCalendar'

const MyEventsCarousel = ({
  events,
  section,
  totalCount,
  loadNextPageData,
  currentPage,
  isMoreEventsCarousel = false,
  slidesPerViewOnLargeScreen = 2.5
}) => {
  const { AddToCalendarDialog, handleAddToCalendarClick } =
    useEventAddToCalendar()
  if (!events || events.length <= 0) {
    return <></>
  }
  const [slidesOffsetBefore, slidesOffsetAfter] = [0, 0]
  // GA `location` (surface) for community_event_card_click. `section` is the
  // pagination key ('myEvents' | 'past'); the related carousel has none.
  const gaLocation = isMoreEventsCarousel
    ? 'related'
    : section === 'past'
    ? 'past'
    : 'my_events'
  return (
    <Box>
      <Box display='flex' gap='2em' flexDirection='column'>
        <Carousel
          card={isMoreEventsCarousel ? EventCard : EventCarouselCard}
          data={events}
          fetchNextData={loadNextPageData}
          handleEventAddToCalendarClick={handleAddToCalendarClick}
          totalCards={totalCount}
          pageNumber={currentPage}
          section={section}
          location={gaLocation}
          mx={['16px', '16px', '16px', '0px']}
          breakpoints={{
            0: {
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            320: {
              slidesPerView: 1.45,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            525: {
              slidesPerView: 2,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            [breakpoints[0]]: {
              slidesPerView: 2,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            790: {
              slidesPerView: 2,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            900: {
              slidesPerView: 2,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            [breakpoints[1]]: {
              slidesPerView: slidesPerViewOnLargeScreen,
              spaceBetween: 20,
              slidesOffsetBefore,
              slidesOffsetAfter
            },
            [breakpoints[2]]: {
              slidesPerView: slidesPerViewOnLargeScreen,
              slidesOffsetBefore: 0,
              spaceBetween: 20,
              slidesOffsetAfter: 0
            }
          }}
        />
        {AddToCalendarDialog}
      </Box>
    </Box>
  )
}

export default MyEventsCarousel
